// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { TypographyProps } from "@insite/mobius/Typography";
import xProductPartNumbersStyles from "@sc/App/SharedStyles/ProductPartNumbersStyles";
import { css } from "styled-components";

productPartNumbersStyles.container = {
    gap: 0,
    offsetCss: css`
        &&& {
            display: flex;
            flex-direction: column;
            margin-bottom: 8px;
            &:empty {
                display: none;
            }
        }
    `,
};

productPartNumbersStyles.erpNumberLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.erpNumberValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.customerNameLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.customerNameValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.manufacturerItemLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.manufacturerItemValueText = {
    ...xProductPartNumbersStyles.value,
};
